module.exports = __webpack_public_path__ + "static/media/placeholder.b1c0b7e1.svg";